module.exports = __webpack_public_path__ + "img/Payangel_Business_main.2a69cb29.svg";